import React from 'react';
import WebpackerReact from 'webpacker-react';
import RecordsReport from '../components/admin/Clients/RecordsReport';

const ClientsV2RecordsReport = (props) => <RecordsReport {...props} />;

export default ClientsV2RecordsReport;
WebpackerReact.setup({ ClientsV2RecordsReport });
